import { defineComponent as _defineComponent } from 'vue'
import CardRelatorioParecerReferencial from './components/CardRelatorioParecerReferencial.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'RelatorioParecerReferencial',
  setup(__props) {


return { __sfc: true,CardRelatorioParecerReferencial }
}

})